<template>
    <form class="shaded m-5" @submit.prevent.stop="save" novalidate>
        <div class="row">
            <div class="col-sm-9">
                <div class="form-group" :class="{ error: $v.form.name.$error }">
                    <label class="full">
                        Name
                        <span class="brand">
                            *
                        </span>
                        <input type="text" v-model="form.name" @input="$v.form.name.$touch">
                    </label>

                    <div v-if="$v.form.name.$error" class="messages">
                        <span v-if="!$v.form.name.required">Name is required.</span>
                        <span v-if="!$v.form.name.minLength">Name must have at least 3 characters.</span>
                    </div>
                </div>

                <!-- <div class="form-group">
                    <label class="full">
                        Billing name
                        <input type="text" v-model="form.billingName">
                    </label>
                </div> -->
            </div>

            <div class="col-sm-3">
                <div class="form-group">
                    <label class="full">
                        Code
                        <input type="text" v-model="form.code">
                    </label>
                </div>
            </div>

            <!-- <div class="col-sm-3">
                <div class="form-group">
                    <label class="d-flex align-items-center ml-5 py-4">
                        Active
                        <toggle-button
                            class="ml-3"
                            v-model="form.isActive"
                            :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </label>
                </div>
            </div> -->
        </div>

        <!-- <h5 class="mt-5">Capacity</h5>

        <div class="form-group row">
            <div v-if="showCapacity" class="col-sm-6">
                <label class="full">
                    Total capacity

                    <input type="number" v-model="form.capacity">
                </label>

                <div class="italic fs-smaller dark mt-2">This set the lotal limit per event.</div>
            </div>

            <div class="col-sm-6 d-flex align-items-center">
                <checkbox @input="toggleCapacity" v-model="form.capacityUnlimited">
                    Unlimited sales
                </checkbox>
            </div>
        </div> -->

        <h5 class="mt-5">PRICES - PVP</h5>

        <div class="form-group row">
            <div v-if="taxes" class="col-sm-2">
                <label class="full">Tax</label>

                <v-select
                    v-model="selectedVatType"
                    :options="taxes"
                    placeholder="- Select tax -"
                    :searchable="true"
                    label="description"
                    @input="updateVatTypes">
                </v-select>
            </div>

            <div class="col-sm-9 d-flex align-items-center">
                <checkbox v-model="form.prices[0].priceIncludeTaxes">
                    Price with taxes
                </checkbox>
            </div>
        </div>
        <div class="form-group row">
            <!-- <div class="col-sm-12" :class="{ error: $v.form.priceTotal.$error }"> -->
            <div class="col-sm-12">


                <div class="row mb-2" v-for="price,index in form.prices">

                    <div class="col-sm-2">
                        <label class="full">
                            Price
                            <span class="brand">
                                *
                            </span>

                        </label>
                        <div class="d-flex">
                            <!-- <input class="glued-right w-100" type="number" v-model="price.value" @input="$v.form.pricesTotal.$touch"> -->
                            <input class="glued-right w-100" type="number" v-model="price.value" @input="$v.form.prices.$each[index].$touch">
                            <div class="glued-left" :class="{ 'color-6': $v.form.prices.$each[index].value.$error }">€</div>
                        </div>
                    </div>

                    <div class="col-sm-8">
                        <label class="full">
                            Label
                            <span class="brand">
                                *
                            </span>

                        </label>
                        <input type="text" v-model="price.name" :class="{'border-color-6': $v.form.prices.$each[index].name.$error}" placeholder="PVP Name" @input="$v.form.prices.$each[index].$touch">
                    </div>

                    <div class="col-sm-2 d-flex align-items-center" v-if="form.prices.length > 1">
                        <div class="row">
                            <i class="ico ico-delete m-0 fs-large medium pointer" @click="removePrice(index)"></i>
                        </div>
                    </div>

                    <div class="col-sm-4 color-6">
                        <div v-if="$v.form.prices.$each[index].$error" class="messages">
                            <span v-if="$v.form.prices.$each[index].value.$error">Price is required.</span>
                            <span v-if="$v.form.prices.$each[index].name.$error">Label is required.</span>
                        </div>
                    </div>

                </div>


                <div class="add d-flex align-items-center pointer fs-small bold my-3">
                    <span @click="addPrice">
                        <i class="ico-add fs-smallest add-circle color-1"></i> New PVP
                    </span>
                </div>

                <!-- <div v-if="$v.form.priceTotal.$error" class="messages">
                    <span v-if="!$v.form.priceTotal.required">Price is required.</span>
                    <span v-if="!$v.form.priceTotal.withParams">Price must be a number.</span>
                </div> -->



            </div>
            <!-- <div v-if="priceTypes" class="col-sm-3">
                <label class="full">&nbsp;</label>

                <v-select
                    v-model="selectedPriceType"
                    :options="priceTypes"
                    placeholder="- Select type -"
                    :searchable="false"
                    label="description"
                    @input="updateTypes">
                </v-select>
            </div> -->
        </div>

        <div class="form-group row">
            <div class="col-sm-12">
                <label class="full">
                    Additional description
                    <textarea v-model="form.description" placeholder="e.g. Alert for high temperatures."></textarea>
                </label>
                <div class="italic fs-smaller dark mt-2">This message is public and is shown on the booking screen.</div>
            </div>
        </div>

        <div class="form-group row pt-4" v-if="false">
            <div class="col-sm-12">
                <h5>
                    Advanced options
                    <div class="fs-small normal mt-2 mb-3">Set options for reservations with this extra.</div>
                </h5>

                <div class="form-group">
                    <label class="d-flex pb-1">
                        Allow commission fee
                        <toggle-button
                            class="ml-auto"
                            v-model="form.allowCommissionFee"
                            :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </label>
                </div>

                <!-- <div class="form-group">
                    <label class="d-flex pb-3">
                        Exclude price discounts
                        <toggle-button
                            class="ml-auto"
                            v-model="form.excludePriceDiscounts"
                            :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </label>
                </div> -->
            </div>
        </div>
    </form>
</template>

<script>
    import { mapGetters } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import { required, minLength, numeric, withParams } from 'vuelidate/lib/validators'

    export default {
        data: function() {
            return {
                form: {
                    vatType: null,
                    isActive: true,
                    name: '',
                    priceType: null,
                    priceTotal: '',
                    prices:[
                        {
                            id:null,
                            name: null,
                            netPrice: null,
                            grossPrice: null,
                            value: null,
                            priceIncludeTaxes: true,
                            vatType: null
                        }
                    ]
                },
                priceTax: 0.00,
                priceNet: 0.00,
                selectedPriceType: null,
                selectedVatType: null,
                showCapacity: true,
            }
        },
        validations: {
            form: {
                name: {
                    required,
                    minLength: minLength(3),
                },
                prices: {
                    $each: {
                        value: {
                            required
                        },
                        name: {
                            required
                        }
                    }
                }
                // priceTotal: {
                //     required,
                //     withParams: ({ type: 'numeric' }, (value) => !isNaN(value)),
                // }
            }
        },
        created: function() {
            if (this.getSelectedExtra) {
                this.form = JSON.parse(JSON.stringify(this.getSelectedExtra));
                this.toggleCapacity();
            }
            else {
                this.form.isActive = true;
            }

            //set vat type
            if(this.form.prices[0].vatType == null){
                this.selectedVatType = this.taxes[0]
                this.form.vatType = this.taxes[0]
            } else {
                this.selectedVatType = this.taxes.filter(vatType => {
                    return vatType.id == this.form.prices[0].vatType
                })[0]
            }
        },
        asyncComputed: {
            async priceTypes() {
                try {
                    let response = await axios.get('/api/settings/GetComponentExtraPriceTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Map FK information through selects

                        if (this.form.priceType) {
                            this.selectedPriceType = response.data.find(item => item.id === this.form.priceType);
                        }
                        else {
                            this.selectedPriceType = response.data[0];
                            this.form.priceType = response.data[0].id;
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error.response.data.message);
                }
            },
        },
        computed: {
            ...mapGetters([
                'getSelectedExtra',
                'getVatTypes'
            ]),
            taxes: function () {
                return this.getVatTypes
            }
        },
        methods: {
            updateTypes: function() {
                this.form.priceType = this.selectedPriceType.id || null;
                this.formatValue();
            },
            updateVatTypes: function() {
                this.form.prices[0].vatType = this.selectedVatType.id || null;
            },
            toggleCapacity: function() {
                if (this.form.capacityUnlimited) {
                    this.form.capacity = 0;
                    this.showCapacity = false;
                }
                else {
                    this.showCapacity = true;
                }
            },
            formatValue: function() {
                if (this.form.priceTotal || this.form.priceTotal === 0) {
                    this.form.priceTotal = this.formatPrice(this.form.priceTotal);
                }
            },
            addPrice: function() {
                let parentPrice = JSON.parse(JSON.stringify(this.form.prices[this.form.prices.length-1]))
                console.log(parentPrice);
                parentPrice.id = null
                parentPrice.name = null
                this.form.prices.push(parentPrice)
                this.$forceUpdate()
                this.$v.form.$touch()
            },
            removePrice: function(index) {
                this.form.prices.splice(index, 1)
            }
        },
        watch: {
            $v: {
                handler: function (n, o) {
                    var toggleIsDisabled = (n.form.$invalid || n.form.$error) ? true : false;

                    this.$emit('toggleIsDisabled', toggleIsDisabled);

                    // Can we save? Have all validations been passed?
                    // Then we'll send the 'actual' form so we can
                    // set it as selectedItem

                    if (!toggleIsDisabled) {
                        this.$emit('readyToSave', this.form);
                    }
                },
                deep: true
            }
        },
        components: {
            vSelect: extendedVSelect,
        }
    }
</script>



// WEBPACK FOOTER //
// ExtraForm.vue?190a32d4